export default class BrowserStorage {

    constructor(_namespace, useSessionStorage = false)
    {
      this.namespace = _namespace;
      this.useSessionStorage = useSessionStorage;
      this.store = this.useSessionStorage ? window.sessionStorage : window.localStorage;
    }
  
    _getCoreObject()
    {
      var serializedResult = this.store.getItem(this.namespace);
      if(serializedResult === null || typeof(serializedResult) === typeof(undefined))
      {
        return null;
      }
  
      var deserializedResult = JSON.parse(serializedResult);
      return deserializedResult;
    }
  
    _setCoreObject(value)
    {
      this.store.setItem(this.namespace, JSON.stringify(value));
    }
  
    getter(key)
    {
      var core = this._getCoreObject();
      if(core == null)
      {
        return null;
      }
      return core[key];
    }
  
  
    setter(key, value)
    {
      var core = this._getCoreObject();
      var update = {};
      update[key] = value;
      core = Object.assign({}, core, update);
      this._setCoreObject(core);
      
    }
  }
  